import get from 'lodash/get';
import { Spin, Descriptions, Tag, Space, Image, Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { map } from 'lodash';
import { PlayCircleOutlined } from '@ant-design/icons';
import { productMangement } from '../../redux/actions/productAction';
import { ProductDescriptions } from '../../constants/catalogue';

const ProductDetails = ({ product }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [productDetails, setProductDetails] = useState(null);
  const [videoPreview, setVideoPreview] = useState({
    visible: false,
    filePath: null,
  });

  const fetchProductDetail = () => {
    setLoading(true);
    dispatch(
      productMangement('get.product', {
        id: get(product, 'id'),
        company_id: get(product, 'company_id'),
      })
    )
      .then((result) => {
        setProductDetails(get(result, 'data'));
        setLoading(false);
      })
      .catch(() => {
        setLoading(true);
      });
  };

  const toggleVideoPreview = (filePath = null) => {
    setVideoPreview({
      visible: !get(videoPreview, 'visible'),
      filePath,
    });
  };

  useEffect(() => {
    fetchProductDetail();
  }, []);

  return (
    <Spin spinning={loading}>
      <Space>
        {map(get(productDetails, 'ProductResources'), (resource, index) => {
          if (get(resource, 'type') === 1) {
            return (
              <Image
                key={index}
                src={get(resource, 'file_path')}
                className="img-upload-btn"
                style={{
                  border: ' 1px dashed #d9d9d9',
                }}
              />
            );
          }
          return (
            <div className="img-upload-btn">
              <PlayCircleOutlined
                className="table-icon"
                onClick={() => {
                  toggleVideoPreview(get(resource, 'file_path'));
                }}
              />
            </div>
          );
        })}
      </Space>
      <div className="product-final-confirmation-container">
        <Descriptions bordered column={1} size="small">
          {map(ProductDescriptions, (desciption, index) => (
            <Descriptions.Item key={index} label={get(desciption, 'title')}>
              {get(productDetails, get(desciption, 'key'))}
            </Descriptions.Item>
          ))}
          <Descriptions.Item label="Product Type">
            {get(productDetails, 'is_sample') ? 'Sample' : 'Retail'}
          </Descriptions.Item>
          <Descriptions.Item label="Status">
            {get(productDetails, 'is_active') ? (
              <Tag color="green">Active</Tag>
            ) : (
              <Tag>Inactive</Tag>
            )}
          </Descriptions.Item>
        </Descriptions>
      </div>
      <Modal
        width="50%"
        destroyOnClose
        open={get(videoPreview, 'visible')}
        onOk={toggleVideoPreview}
        onCancel={toggleVideoPreview}
        footer={null}
        className="video-preview-modal"
      >
        <video width="100%" height="300" controls>
          <source src={get(videoPreview, 'filePath')} type="video/mp4" />
          <track
            src="captions_en.vtt"
            kind="captions"
            srcLang="en"
            label="english_captions"
          />
        </video>
      </Modal>
    </Spin>
  );
};

export default ProductDetails;
